import React from "react"
import cn from "classnames";

interface CloseModalButtonProps {
  disabled?: boolean;
  hideOnMobile?: boolean;
  onClick?: () => void;
}

const CloseModalButton: React.FC<CloseModalButtonProps> = ({ disabled, hideOnMobile, onClick }) => {
  const className = cn("Modal-closeButton", { "Modal-closeButton--hideOnMobile": hideOnMobile });
  return (
    <button className={className} disabled={disabled} onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M17 8.41L15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41Z" fill="#2690D8"/>
      </svg>
    </button>
  )
}

export default CloseModalButton
